var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0z",
    fill: "url(#paint0_linear_3040_22908)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.911 17.581a6.785 6.785 0 01-6.784-6.784H25.28v18.98a4.122 4.122 0 11-2.957-3.959v-4.711a8.748 8.748 0 107.578 8.67l.141-9.594a11.578 11.578 0 006.869 2.245V17.58z",
    fill: "url(#paint1_linear_3040_22908)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.63 16.26a6.785 6.785 0 01-6.784-6.783h-4.847v18.98a4.121 4.121 0 11-2.957-3.96v-4.71a8.748 8.748 0 107.578 8.67l.142-9.595a11.578 11.578 0 006.868 2.245v-4.846z",
    fill: "url(#paint2_linear_3040_22908)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.63 17.46a6.785 6.785 0 01-4.182-2.642 6.783 6.783 0 01-2.473-4.021h-3.694v18.98a4.127 4.127 0 01-7.655 2.138 4.126 4.126 0 013.416-7.417V21.03a8.747 8.747 0 00-6.772 14.141 8.747 8.747 0 0014.351-6.716l.142-9.593a11.578 11.578 0 006.868 2.244V17.46z",
    fill: "url(#paint3_linear_3040_22908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3040_22908",
    x1: -0.126,
    y1: 48.126,
    x2: 47.878,
    y2: 0.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3040_22908",
    x1: 14.349,
    y1: 35.341,
    x2: 34.51,
    y2: 15.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5053C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#C90441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#F0014B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF004F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3040_22908",
    x1: 12.767,
    y1: 34.32,
    x2: 34.004,
    y2: 13.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#00C8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#00E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3040_22908",
    x1: 0.87,
    y1: 47.519,
    x2: 47.879,
    y2: 0.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.70571db3401e59cb86595b7452ac80ad.svg";
export { ForwardRef as ReactComponent };